/**
 *
 * Adds a class to container(s) for fallback CSS if a specific CSS attribute is not supported by the browser
 *
 * Usage example (HTML):
 *
 * <div class="fallback-supported-elements-container object-fit-fallback" data-original-style="objectFit" data-fallback-class="fallback-enabled">
 *    <div style="background-image:url(image1.jpg)">
 *      <img class="fallback-supported-element" src="image1.jpg" alt="Image 1" />
 *    </div>
 *    <div style="background-image:url(image2.jpg)">
 *      <img class="fallback-supported-element" src="image2.jpg" alt="Image 2" />
 *    </div>
 *    <div style="background-image:url(image3.jpg)">
 *      <img class="fallback-supported-element" src="image3.jpg" alt="Image 3" />
 *    </div>
 * </div>
 *
 * Usage example (SASS):
 *
 * .fallback-supported-elements-container {
 *    &.object-fit-fallback {
 *        img {
 *            width: 100%;
 *            height: 300px;
 *            object-fit: cover;
 *        }
 *
 *        // Admittedly this is not the most ideal way to do this, to use inline styles and then overwrite them with '!important', but sadly attr() CSS function doesn't really work with URLs yet
 *        &:not(.fallback-enabled) > div {
 *            background-image: none !important;
 *        }
 *
 *        &.fallback-enabled {
 *            img {
 *                display: none;
 *            }
 *
 *            > div {
 *                width: 100%;
 *                height: 300px;
 *                background-size: cover;
 *            }
 *        }
 *    }
 * }
 *
 */

const styleFallback = {
  init: function() {
    const fallbackContainers = document.getElementsByClassName('fallback-supported-elements-container');

    if (fallbackContainers.length) {
      for (const container of fallbackContainers) {
        const fallbackElements = container.getElementsByClassName('fallback-supported-element'),
          originalStyle = container.dataset.originalStyle,
          fallbackClass = container.dataset.fallbackClass;

        // Check the first fallback supported element, if the original style has been successfully computed by the browser
        if (fallbackElements.length && !window.getComputedStyle(fallbackElements[0], null)[originalStyle]) {
          // If not, add class to container to apply fallback styles for the elements
          container.classList.add(fallbackClass);
        }
      }
    }
  }
};

export default styleFallback;
